import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <ContactSection />
        <MediaSection />
        <FeaturesSection />
        <IndexSection />
        <CommentsSection />
        <RankingSection />
        <AppSection />
        <TopicsSection />
        <CarouselSection />
        <AboutSection />
        <CardsSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}